import React, { Component } from 'react';
import firebase, { facebooklogin, googlelogin } from '../utils/firebase';
import { toJSONString, defaultUserData } from '../utils/helpers';
import Toast from './toast';

class RsvpForm extends Component {
  constructor() {
    super();
    this.state = {
      editForm: true,
      guests: [],
      formData: {},
      showSuccessMsg: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGuestChange = this.handleGuestChange.bind(this);
    this.handleChanges = this.handleChanges.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user !== this.props.user) {
      this.changeUserDoc(nextProps.user.email);
      this.userDoc && this.userDoc.get()
        .then((doc) => {
          const data = doc.exists ? doc.data() : {};
          const viewed = data.viewed || [];
          const formData = { ...data, ...this.state.formData, viewed: [new Date(), ...viewed] };
          !doc.exists ? this.userDoc.set(formData) : this.userDoc.update(formData);
          if (formData.saved) {
            const guests = parseInt(formData.guests, 10) || 0;
            this.setState({ formData, guests: Array(guests).fill('').map((x, i) => i), editForm: false });
          } else {
            this.setState({ formData, editForm: true });
          }
        });
    }
  }

  changeUserDoc(email = '') {
    if (email) {
      this.userDoc = firebase.firestore().collection('users').doc(email);
    }
  }


  handleSubmit(e) {
    e.preventDefault();
    const { user } = this.props;
    const data = toJSONString(e.target);
    this.changeUserDoc(data.email);

    if (this.userDoc) {
      const unsavedFormData = {
        ...defaultUserData, ...data, updated: new Date(), saved: true,
      };
      this.userDoc.update(unsavedFormData)
        .then(() => {
          this.setState({ editForm: false, showSuccessMsg: true });
          setTimeout(() => this.setState({ showSuccessMsg: false }), 5000);
        })
        .catch((error) => {
          console.error('Error writing document: ', error);
          this.setState({ showErrorSignInMsg: true, unsavedFormData: unsavedFormData });
        });
    }
  }


  handleGuestChange(e) {
    e.preventDefault();
    const value = parseInt(e.target.value, 10) || 0;
    this.handleChanges(e);
    this.setState({ guests: Array(value).fill('').map((x, i) => i) });
  }

  handleChanges(e) {
    e.preventDefault();
    const { value = '', name } = e.target;
    const { user } = this.props;
    if (user && this.userDoc) {
      this.userDoc.update({ [name]: value });
    }
    this.setState({ formData: { ...this.state.formData, [name]: value } });
  }

  renderHeader() {
    return (
      <div className="row">
        <div className="col-12 text-center">
          <span className="d-block font-alt2 text-extra-large text-gray-700">Come and celebrate with us!</span>
          <h3 className="font-alt letter-spacing-1 mb-0 mt-2 text-uppercase title-small">RSVP</h3>
          <span className="bg-base-color d-block mt-1 mx-auto sep-line-thick" />
          <span className="d-block font-alt2 mt-4 text-gray-600 text-small">Please RSVP by January 5, 2019.</span>
        </div>
      </div>
    );
  }

  renderForm() {
    const user = this.props.user || {};
    const {
      editForm, guests, formData, showSuccessMsg,showErrorSignInMsg
    } = this.state;
    const editFormProps = editForm ? {} : { readOnly: true, disabled: true };
    const signedInUserProps = user.email ? { ...editFormProps, readOnly: true } : { ...editFormProps };
    return (
      <form onSubmit={this.handleSubmit} id="form-rsvp" encType="application/json">
        {showSuccessMsg && (<Toast message="Sent" />)}
        {!editForm && (
        <div className="col-12 mt-4 text-center">
          <button type="button" onClick={() => this.setState({ editForm: true })} className="btn btn-small btn-lg-medium yellow border-yellow">Edit</button>
        </div>
        )}
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="rsvp-name" className="text-medium">Name:</label>
              <input type="text" name="name" id="rsvp-name" className="font-alt form-control required" placeholder="Your Full Name" value={user.displayName} {...signedInUserProps} required />
            </div>

          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="rsvp-email" className="text-medium">Email:</label>
              <input type="email" name="email" id="rsvp-email" className="font-alt form-control required email" placeholder="Your Email Address" value={user.email} {...signedInUserProps} required />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="rsvp-events" className="text-medium">Events:</label>
              <select name="events" id="rsvp-events" onChange={this.handleChanges} value={formData.events} className="font-alt form-control required" {...editFormProps} required>
                <option value="">- Please Select -</option>
                <option value="Ceremony &amp; Reception">Ceremony &amp; Reception</option>
                <option value="Ceremony Only">Ceremony Only</option>
                <option value="Reception Only">Reception Only</option>
                <option value="Sory, Can't Make Either">Sory, Can't Make Either</option>
              </select>
            </div>

          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="rsvp-guests" className="text-medium">Guests:</label>
              <select name="guests" id="rsvp-guests" onChange={this.handleGuestChange} value={formData.guests} className="font-alt form-control required" {...editFormProps} required>
                <option value="">- Please Select -</option>
                {[0, 1, 2, 3, 4, 5, 6, 7].map((num, index) => {
                  const text = num ? `${num} Guests` : 'No Guests';
                  return (<option key={num} value={num}>{text}</option>);
                })}
              </select>
            </div>

          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12">
            <h4>
              Me:
            </h4>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="first_name" className="text-medium">First Name:</label>
              <input type="text" name="first_name" id="first_name" value={formData.first_name} className="font-alt form-control required" placeholder="First Name" onChange={this.handleChanges} {...editFormProps} required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="last_name" className="text-medium">Last Name:</label>
              <input type="text" name="last_name" id="last_name" value={formData.last_name} className="font-alt form-control required" placeholder="Last Name" onChange={this.handleChanges} {...editFormProps} required />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="home_address" className="text-medium">Home Address:</label>
              <input type="text" name="home_address" id="home_address" value={formData.home_address} className="font-alt form-control" placeholder="Home Address" onChange={this.handleChanges} {...editFormProps} />
            </div>
          </div>
        </div>
        {guests.map((item, index) => {
          const guestNum = index + 1;
          const nameField = `guest_${guestNum}_first_name`;
          const lastNameField = `guest_${guestNum}_last_name`;
          return (
            <div key={index} className="row mt-4">
              <div className="col-12">
                <h4>
                  {`Guest: ${guestNum}`}
                </h4>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor={nameField} className="text-medium">First Name:</label>
                  <input type="text" name={nameField} id={nameField} value={formData[nameField]} className="font-alt form-control required" placeholder="First Name" onChange={this.handleChanges} {...editFormProps} required />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor={lastNameField} className="text-medium">Last Name:</label>
                  <input type="text" name={lastNameField} id={lastNameField} value={formData[lastNameField]} className="font-alt form-control required" placeholder="Last Name" onChange={this.handleChanges} {...editFormProps} />
                </div>
              </div>
            </div>
          );
        })}

        <div className="row">
          <div className="col-12">
            <label htmlFor="rsvp-message" className="text-medium">Additional Information:</label>
            <textarea name="message" id="rsvp-message" onChange={this.handleChanges} value={formData.message} className="font-alt form-control" rows="6" placeholder="eg. Vegetarian Requests" {...editFormProps} />
          </div>

          {editForm && (
          <div className="col-12 mt-4 text-center">
            {showErrorSignInMsg && this.renderSignInMethods()}
            <button type="submit" id="btn-form-rsvp" className="btn btn-small btn-lg-medium btn-base-color border-black">RSVP Now</button>
          </div>
          )}
        </div>
      </form>
    );
  }

  renderSignInMethods(disableToast) {
    const {
      showErrorSignInMsg,
    } = this.state;
    const { user } = this.props;
    if (!user) {
      return (
        <div className="text-center">
          {showErrorSignInMsg && !disableToast && (<Toast variant="warning" message="Please Sign in Using Facebook or Google then click Save" />)}
          <h4 className="text-center">Sign In to RSVP</h4>
          <i className="fab fa-facebook-square fa-4x blue" style={{ marginRight: '33px' }} onClick={() => { !user && facebooklogin(); }} />
          <i className="fab fa-google fa-4x muted" onClick={() => { !user && googlelogin(); }} />
        </div>
      );
    }
    return null;
  }

  render() {
    const { user } = this.props;
    return (
      <div>
        {this.renderHeader()}
        {this.renderSignInMethods(true)}
        {this.renderForm()}
      </div>
    );
  }
}
const RsvpSection = props => (
  <section id="rsvp" className="bg-white section-divider section-divider-y">
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-md-8 col-lg-5">
          <img src="./img/hawaii/wedding_top_view.jpg" alt="" className="img-fluid" />
        </div>
        <div className="col-lg-7 pl-lg-5 pt-5 pt-lg-0">
          <RsvpForm {...props} />
        </div>
      </div>
    </div>
  </section>
);
export default RsvpSection;
